/* URINKING · Bewegung
   Angelegt 29.08.2026. Zustaende stehen in assets/uk-bewegung.css.

   EIN Observer fuer die ganze Seite, nicht einer je Element. Er
   setzt eine Klasse, sonst nichts - die Gestaltung liegt
   vollstaendig im Stylesheet. Wer hier Werte findet, hat einen
   Fehler gefunden.

   JEDES ELEMENT WIRD NACH DEM ERSTEN MAL ABGEMELDET. Ein Element,
   das beim Hochscrollen zurueckspringt und erneut einfliegt,
   liest sich als Fehler, nicht als Effekt - und es kostet bei
   jedem Scrollen wieder Rechenzeit.

   OHNE JAVASCRIPT PASSIERT NICHTS, und das ist richtig: Die
   Elemente stehen dann sofort an ihrem Platz, weil der Endzustand
   der Normalfall ist (siehe Kopf von uk-bewegung.css).

   Kein 'const', kein Pfeil, kein Optional Chaining: Dawn liefert
   ES5-freundliches JS aus, und diese Datei laeuft ohne
   Transpilierung. */
(function () {
  'use strict';

  var ziele = document.querySelectorAll('.uk-auf');
  if (!ziele.length) return;

  var i;

  /* Zwei Gruende, sofort fertig zu sein: Der Besucher will keine
     Bewegung, oder der Browser kennt den Observer nicht. In
     beiden Faellen ist der Endzustand die richtige Antwort. */
  var sparsam = window.matchMedia &&
                window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (sparsam || !('IntersectionObserver' in window)) {
    for (i = 0; i < ziele.length; i++) {
      ziele[i].classList.add('uk-auf--da');
    }
    return;
  }

  var beobachter = new IntersectionObserver(function (eintraege) {
    for (var k = 0; k < eintraege.length; k++) {
      var e = eintraege[k];
      if (!e.isIntersecting) continue;
      e.target.classList.add('uk-auf--da');
      beobachter.unobserve(e.target);
    }
  }, {
    /* -12 % am unteren Rand: Das Element loest erst aus, wenn es
       ein Stueck weit im Bild steht. Bei 0 zuendet es genau an
       der Kante und die Ueberblendung laeuft ausserhalb des
       Sichtfelds ab - man sieht sie nie. */
    rootMargin: '0px 0px -12% 0px',
    threshold: 0.05
  });

  for (i = 0; i < ziele.length; i++) {
    beobachter.observe(ziele[i]);
  }
})();
